export default __webpack_public_path__ + "static/media/logo.a8c5f14d.svg";